import React from 'react';
import clsx from 'clsx';

import styles from './styles/button.module.scss';

type Props = {
  children: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  className?: string;
  style?: React.CSSProperties;
  type?: 'button' | 'submit' | 'reset';
  isDisabled?: boolean;
  isSecondary?: boolean;
  isOutline?: boolean;
};

const Button = ({
  children,
  onClick,
  className,
  style,
  type,
  isDisabled,
  isSecondary,
  isOutline,
  ...props
}: Props) => (
  <button
    className={clsx(styles.button, className, {
      [styles.secondary]: isSecondary,
      [styles.outline]: isOutline
    })}
    style={style}
    disabled={isDisabled}
    type={type}
    onClick={onClick}
    {...props}
  >
    {children}
  </button>
);

export default Button;
